import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../query-keys';
import { getStrategies, getStrategySchema } from '../endpoints/strategies';

export function useStrategies() {
  return useQuery({
    queryKey: queryKeys.strategies.all(),
    queryFn: getStrategies,
    staleTime: 5 * 60 * 1000,
  });
}

export function useStrategySchema(type: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.strategies.schema(type),
    queryFn: () => getStrategySchema(type),
    staleTime: Infinity,
    enabled,
  });
}
